import * as moment from "moment";
import * as React from 'react';
import { Link } from 'react-router-dom';
import * as DTOS from "../../../FeralScan.dtos";
import * as DashboardActionCreators from "../../../actions/dashboard.actions";
import { withTheme } from '../../../common/withTheme';
import { Map } from '../../Map/Map';
import { MarkerIcon } from "../../Map/Platypus/MapMarker";
import ContentContainer from '../../Content/ContentContainer';
import PlotEventList from '../PlotEvent/PlotEventList';
import { ContinuousSpanStringBuilder } from "../../../helpers/graphHelper";
import PlotBadgeContainer from "./PlotBadgeContainer";
import * as classNames from "classnames";
import ModalMessage from "../../Common/Modal";
import AdminContactEmailLink from "../../Content/AdminContactEmailLink";

type PlatypusPlotDetailProps = {
    activePlot: DTOS.Plot;
    activePlotId: number;
    currentUser: DTOS.User;
    dateFormat: string;
    dateTimeFormat: string;
    enableSelectMonitoringPlot: boolean;
    googleMapURL: string;
    mapMarkerComponent: any;
    monitoringPlot: boolean;
    plotLoading: boolean;
    plotSummary: DTOS.PlotSummary;
}

type PlatypusPlotDetailActions = {
    deletePlotEvent: Function;
    flagPlot: typeof DashboardActionCreators.flagPlotRequest;
}

type PlatypusPlotDetailAllProps = PlatypusPlotDetailProps & PlatypusPlotDetailActions;

interface IPlatypusPlotdetailState {
    showModal: boolean;
}

class PlatypusPlotDetail extends React.PureComponent<PlatypusPlotDetailAllProps, any> {
    constructor(props, context) {
        super(props, context);
        this.state = {
            showModal: false
        };

        this.onToggleRegisterPlot = this.onToggleRegisterPlot.bind(this);
        this.onToggleModal = this.onToggleModal.bind(this);
        this.onStopMonitoring = this.onStopMonitoring.bind(this);
    }

    onToggleModal() {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    onStopMonitoring() {
        this.setState({
            showModal: false
        });

        this.onToggleRegisterPlot();
    }

    onToggleRegisterPlot() {
        this.props.flagPlot(this.props.activePlot);
    }

    render() {
        const { activePlot, currentUser, plotSummary } = this.props;

        /* @TODO This should be done better */
        const icon: MarkerIcon = {
            path: "M-20,0 a20,20 0 1,0 40,0 a20,20 0 1,0 -40,0",
            fillColor: '#CCC8CC',
            fillOpacity: 1,
            anchor: { x: 0, y: 0 },
            strokeWeight: 0,
            scale: 1
        }

        const marker = <this.props.mapMarkerComponent
            key={`mapmarker-${activePlot.id}`}
            icon={icon}
            id={activePlot.id}
            interactive={false}
            popup={undefined}
            position={{ lat: activePlot.latitude, lng: activePlot.longitude }}
            isOpen={false}
            toggleMarkerPopup={undefined}
        >
        </this.props.mapMarkerComponent>

        const statusBadge = <PlotBadgeContainer
            className="mr-1"
            currentPlot={activePlot}
        />

        return (activePlot ?
            <ContentContainer addMargin={false}>
                <div className="row no-gutters px-3 pb-3">
                    <div className="col-12 border-bottom my-2 ml-xl-1">
                        <h2>
                            {statusBadge} 
                            <span className="align-middle">{activePlot.name}</span>
                        </h2>
                    </div>
                    <div className="col-xl-3 col mb-2">
                        {plotSummary ?
                            <div className="card mx-xl-1">
                                <div className="card-body">
                                    <h4 className="card-title">Site Details</h4>
                                    <div className="card-text">
                                        <hr />
                                        {/*this.props.monitoringPlot
                                                    ? <>
                                                        <span>
                                                            <i className="fa fa-check pr-2" />You are monitoring this site
                                                        </span>
                                                        <hr />
                                                    </>
                                                : null*/}

                                        {activePlot.nearestSuburb ? <div className="mb-1"><strong>Nearest Town/Suburb:</strong>  {activePlot.nearestSuburb}</div> : undefined}
                                        {activePlot.waterBody ? <div className="mb-1"><strong>Water Body:</strong>  {activePlot.waterBody}</div> : undefined}
                                        {activePlot.nearestSuburb || activePlot.waterBody ? <hr /> : null}

                                        {plotSummary ? <>
                                            {plotSummary.years && plotSummary.years.length > 0 ? <div className="mb-1"><strong>Years:</strong> {ContinuousSpanStringBuilder(plotSummary.years)}</div> : undefined}
                                            <div className="mb-1"><strong>Last Scan:</strong> {plotSummary.lastPlotEvent ? moment(plotSummary.lastPlotEvent).format(this.props.dateFormat) : 'Never'}</div>
                                            {plotSummary.participantCount > 0 ? <div className="mb-1"><strong>Participants:</strong> {plotSummary.participantCount}</div> : undefined}
                                            {plotSummary.primaryValue ? <div className="mb-1"><strong>{plotSummary.primaryValue.label}:</strong>  {plotSummary.primaryValue.value}</div> : undefined}
                                            {plotSummary.plotEventCount > 0 ? <div className="mb-1"><strong>Total Scans:</strong> {plotSummary.plotEventCount}</div> : undefined}
                                            {plotSummary.plotEventCount > 0 ? <div className="mb-1"><strong>Average Sightings/Scan:</strong> {plotSummary.plotEventCount > 120 ? (plotSummary.primaryValue.value / plotSummary.plotEventCount).toFixed(2) : (plotSummary.primaryValue.value / plotSummary.plotEventCount).toFixed(1)}</div> : undefined}
                                        </>
                                            : null
                                        }
                                        {currentUser
                                            ? <>
                                                <hr />
                                                {
                                                    this.props.monitoringPlot
                                                        ? <Link className="btn btn-primary btn-block"
                                                            to={`${this.props.activePlotId}/add-data`}><i className="fa fa-plus-square pr-2" />Add Data
                                                                </Link>
                                                        : null
                                                }
                                                {!this.props.monitoringPlot && this.props.enableSelectMonitoringPlot ?
                                                    <button onClick={this.onToggleRegisterPlot} className="btn btn-outline-dark btn-block"><i className="fa fa-sign-in pr-1" /> Select Site for Monitoring</button> :
                                                    <button onClick={this.onToggleModal} className="btn btn-outline-danger btn-block"><i className="fa fa-ban pr-1" /> Stop Monitoring Site</button>
                                                }
                                            </>
                                            : undefined
                                        }
                                    </div>
                                </div>
                            </div> : undefined}

                        {this.props.monitoringPlot ?
                            <p className="alert alert-info mx-xl-1">
                                If you'd like to report any special observations (e.g. unusual platypus behaviour,
                                        finding illegal nets or a dead platypus), or request a change to a site, click <AdminContactEmailLink subject={`Site:%20${this.props.activePlot.id}`} title="here"/>.
                                    </p>
                            : undefined
                        }

                    </div>
                    {
                        activePlot.plotPhoto ? <div className="col-xl-4 col-12 mb-2">
                            <div className="card mx-xl-1">
                                <div className="card-body">
                                    <h4 className="card-title">Site Photo</h4>
                                    <hr />
                                    <img className="img-thumbail img-fluid" src={`/file/${activePlot.plotPhoto.fileNameWithExtension}`} />
                                </div>
                            </div>
                        </div>
                            : undefined
                    }

                    <div
                        className={classNames({
                            "col-xl-9": !activePlot.plotPhoto,
                            "col-xl-5": activePlot.plotPhoto !== undefined
                        },
                            "col-12 text-right mb-2")}
                        style={{ minHeight: "400px" }}>

                        <div className="card mx-xl-1 h-100">
                            <div className="card-body">
                                <Map
                                    lng={activePlot.longitude}
                                    lat={activePlot.latitude}

                                    defaultZoom={10}
                                    googleMapURL={this.props.googleMapURL}
                                    gridSize={30}
                                    height="95%"
                                    interactive={false}
                                    layers={undefined}
                                    mapType="normal"
                                    mapTypeId={"roadmap"}
                                    markers={[marker]}

                                    toggleNewMarkerPopup={undefined}

                                    zoomInOnClick={false}
                                />
                                <div className="text-muted small text-right">lat: {activePlot.latitude}, lng: {activePlot.longitude}</div>
                            </div>
                        </div>
                    </div>

                    {this.props.currentUser && this.props.monitoringPlot ?
                        <>
                            <hr className="w-100" />
                            <div className="col-xl-6 col">
                                <h3>My most recent scans</h3>
                                <p>If you've made a mistake when entering a record, delete the incorrect entry from this list, then replace the deleted entry by submitting a new record with correct details.</p>
                                <PlotEventList
                                    className="mx-2 my-2"
                                    dateTimeFormat={this.props.dateTimeFormat}
                                    hidePaginationControls={true}
                                    hideSortControls={true}
                                    plotEvents={this.props.activePlot.plotEvents}
                                    onDeletePlotEvent={this.props.deletePlotEvent}
                                    plotEventsLoading={this.props.plotLoading}
                                />
                            </div>
                        </>
                        : undefined
                    }
                </div>
                <ModalMessage
                    onRequestClose={this.onToggleModal}
                    onNegativeResponse={this.onToggleModal}
                    onPositiveResponse={this.onStopMonitoring}
                    isOpen={this.state.showModal}
                    label="Stop Monitoring Site"
                    message="Are you sure you want to stop monitoring this site?"

                    positiveResponseLabel="Stop monitoring"
                    positiveResponseClass="btn-danger"
                    negativeResponseLabel="Cancel"
                    negativeResponseClass="btn-secondary"
                />
            </ContentContainer > : null
        );
    }
}

export default withTheme<PlatypusPlotDetailAllProps>(PlatypusPlotDetail);